import eTournamentControllerTypes from './eTournamentControllerTypes';

export default {
  EALCT_CARD: `${eTournamentControllerTypes.ETCT_ARCHIVE_LIST}__card`,
}
